import { render, staticRenderFns } from "./Polls.vue?vue&type=template&id=f31ef2bc&"
import script from "./Polls.vue?vue&type=script&lang=js&"
export * from "./Polls.vue?vue&type=script&lang=js&"
import style0 from "./Polls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports